/* MEPZITE · Afiya 11.11 · native scroll enhancement, no cart or pricing logic. */
(() => {
  'use strict';
  if (window.MPZAfiyaPages) return;
  const ready = new WeakSet();
  const cleanups = new Set();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    document.querySelectorAll('.mpz-afiya-surface[data-mpz-edit="scarves"]').forEach(section => {
      if (ready.has(section)) return;
      const rail = section.querySelector('[data-mpz-rail]');
      const prev = section.querySelector('[data-mpz-prev]');
      const next = section.querySelector('[data-mpz-next]');
      if (!rail || !prev || !next) return;
      ready.add(section);
      section.dataset.mpzRailReady = 'true';
      const update = () => {
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      const move = direction => {
        const card = rail.querySelector('.mpz-edit__item');
        const step = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth * .8;
        rail.scrollBy({ left: direction * step, behavior: reduced.matches ? 'auto' : 'smooth' });
      };
      const backward = () => move(-1);
      const forward = () => move(1);
      prev.addEventListener('click', backward);
      next.addEventListener('click', forward);
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
      const cleanup = () => {
        prev.removeEventListener('click', backward);
        next.removeEventListener('click', forward);
        rail.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
        delete section.dataset.mpzRailReady;
        ready.delete(section);
        cleanups.delete(cleanup);
      };
      cleanups.add(cleanup);
      section.addEventListener('shopify:section:unload', cleanup, { once: true });
    });
  }
  document.addEventListener('shopify:section:load', init);
  window.MPZAfiyaPages = { version: '1.0.0', destroy() { document.removeEventListener('shopify:section:load', init); cleanups.forEach(fn => fn()); delete window.MPZAfiyaPages; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
